import { render, staticRenderFns } from "./PrintShopsTable.vue?vue&type=template&id=066ecb7c&"
import script from "./PrintShopsTable.vue?vue&type=script&lang=js&"
export * from "./PrintShopsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/blocks/PrintShopsTable.vue
// module id = null
// module chunks = 